import {Wrapper} from './OperationIntelligenceMobile.style';
import box from '../../../../public/image/whyUs/mobile/operationalintelligence/box.webp';
import key from '../../../../public/image/whyUs/mobile/operationalintelligence/key.webp';
import laptop from '../../../../public/image/whyUs/mobile/operationalintelligence/laptop.webp';
import money from '../../../../public/image/whyUs/mobile/operationalintelligence/money.webp';
import grow from '../../../../public/image/whyUs/mobile/operationalintelligence/grow.webp';
import cam from '../../../../public/image/whyUs/mobile/operationalintelligence/cam.webp';
import logo from '../../../../public/image/whyUs/mobile/operationalintelligence/logo.webp';
import {useRef} from 'react';

const OperationIntelligence = ({active}) => {
  const wrap = useRef();

  const bg_1 = '#db4e1b';
  const bg_2 = 'white';
  const font_2 = '#575756';
  const font_1 = 'white';
  const content = [
    {
      title: 'Live Productivity Analysis',
      icon: grow.src,
      image: '',
      paragraph: `The <span class="bold darkblue">“LMS”</span> model facilitates <span class="bold">live visibility</span> and precise assessment of effective hours compared with ineffective ones and help in the <span class="bold">identification of quality error stimulants.</span>`,
      bgColor: bg_1,
      fontColor: font_1,
    },
    {
      title: 'Quality Standardization Methodology',
      icon: cam.src,
      image: '',
      paragraph: `The consistency of product quality is guaranteed through applying our quality standardization methodology powered by <span class="bold">internal quality control guidelines & multiple, interdepartmental auditing layers.</span>`,
      bgColor: bg_2,
      fontColor: font_2,
    },
    {
      title: 'Profitability Maximization Analytics',
      icon: money.src,
      image: '',
      paragraph: `The profitability maximization analytics help your business reach its <span class="bold">full profitability potentials</span> through the utilization of <span class="bold">multiple cost management parameters.</span>
      `,
      bgColor: bg_1,
      fontColor: font_1,
    },
    {
      title: 'Optimized Product Value',
      icon: box.src,
      image: '',
      paragraph: `The conduction of product workflow mapping <span class="bold">identifies any wasted efforts</span> to manage them adequately and optimize each product’s value. With the <span class="darkblue bold">“LMS”</span> Model, your decision-making process relies on the <span class="bold">firm foundation of multidimensional KPIs analysis</span> through applying multiple, powerful statistical methods.`,
      bgColor: bg_2,
      fontColor: font_2,
    },
    {
      title: 'Live Performance Evaluation',
      icon: key.src,
      image: laptop.src,
      paragraph: `Our integrated <span class="bold darkblue">ELEMENTAL SYSTEM</span> provides a <span class="bold">seamless, accurate & live evaluation of each stakeholder’s responsibility</span> within specific time intervals that optimize effective operations streamline.`,
      bgColor: bg_1,
      fontColor: font_1,
    },
  ];

  return (
    <Wrapper secHeight={active ? wrap.current?.clientHeight : 0}>
      <div className='intelligence' ref={wrap}>
        <div className='intelligence__header'>
          <img src={logo.src} alt='' />
        </div>
        <div className='intelligence__content'>
          <div className='intelligence__content__side'></div>
          <div className='intelligence__content__sectionWrapper'>
            {content.map((item, index) => (
              <section key={index}>
                <div className='intelligence__content__sectionWrapper__icon'>
                  <img
                    className='intelligence__content__sectionWrapper__icon__iconImage'
                    src={item.icon}
                    alt=''
                  />
                </div>
                <div
                  className='intelligence__content__sectionWrapper__text'
                  style={{
                    backgroundColor: item.bgColor,
                    color: item.fontColor,
                  }}>
                  {item.image && (
                    <img
                      src={item.image}
                      alt=''
                      className='intelligence__content__sectionWrapper__text__image'
                    />
                  )}
                  <div className='intelligence__content__sectionWrapper__text__title'>
                    {item.title}
                  </div>
                  <div
                    className='intelligence__content__sectionWrapper__text__paragraph'
                    dangerouslySetInnerHTML={{__html: item.paragraph}}></div>
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default OperationIntelligence;
